export default __webpack_public_path__ + "static/media/navbar-img.8acac8ce.svg";